import { useQuery } from "@tanstack/react-query";
import { ClientHandlingErrorStatusCode, EHttpStatusCodeSuccess } from "@devowl-wp/api";
import { useStores } from "../store/root.js";
import { getClient } from "../util/api-fetch.js";
import { QueryKeys } from "../util/query-keys.js";
function useAllUntranslatables(isEnabled = true) {
    const { rcbAuthenticationStore } = useStores();
    const allUntranslatablesQuery = useQuery(QueryKeys.getAllUntranslatables(), async ({ signal })=>{
        const result = await getClient().template.untranslatable.get({
            signal,
            params: {},
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
        switch(result.status){
            case EHttpStatusCodeSuccess.OK:
                return result.response;
            case ClientHandlingErrorStatusCode:
                throw result.error;
            default:
                throw result.response;
        }
    }, {
        enabled: isEnabled && !!rcbAuthenticationStore?.session?.jwt,
        keepPreviousData: true
    });
    return allUntranslatablesQuery;
}
export { useAllUntranslatables };
